import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { CartProvider } from "@/context/CartContext";
import { WishlistProvider } from "@/context/WishlistContext";
import { QuickViewProvider } from "@/context/QuickViewContext";

import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import { QuickViewModal } from "@/components/QuickViewModal";
import { WhatsAppFab } from "@/components/WhatsAppFab";
import { CustomMusicBar } from "@/components/CustomMusicBar";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Wishlist from "@/pages/Wishlist";
import Lookbook from "@/pages/Lookbook";
import About from "@/pages/About";
import Journal from "@/pages/Journal";
import JournalEntry from "@/pages/JournalEntry";
import Stockists from "@/pages/Stockists";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import CheckoutCancel from "@/pages/CheckoutCancel";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const TOAST_OPTIONS = {
    style: {
        background: "#141414",
        border: "1px solid rgba(255,255,255,0.1)",
        color: "#F4F4F0",
        borderRadius: 0,
        fontFamily: "Outfit, sans-serif",
    },
};

function ScrollTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);
    return null;
}

function App() {
    return (
        <BrowserRouter>
            <CartProvider>
                <WishlistProvider>
                    <QuickViewProvider>
                        <ScrollTop />
                        <Routes>
                            {/* Admin routes — no public shell */}
                            <Route path="/admin/login" element={<AdminLogin />} />
                            <Route path="/admin" element={<AdminDashboard />} />

                            {/* Public storefront — full shell */}
                            <Route path="/*" element={<PublicShell />} />
                        </Routes>
                        <Toaster
                            theme="dark"
                            position="bottom-right"
                            toastOptions={TOAST_OPTIONS}
                        />
                    </QuickViewProvider>
                </WishlistProvider>
            </CartProvider>
        </BrowserRouter>
    );
}

function PublicShell() {
    return (
        <div className="min-h-screen flex flex-col bg-[#0C0C0C] text-[#F4F4F0]">
            <Header />
            <main className="flex-1 pt-7">
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/shop" element={<Shop />} />
                    <Route path="/shop/:section" element={<Shop />} />
                    <Route path="/product/:slug" element={<ProductDetail />} />
                    <Route path="/wishlist" element={<Wishlist />} />
                    <Route path="/lookbook" element={<Lookbook />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/journal" element={<Journal />} />
                    <Route path="/journal/:slug" element={<JournalEntry />} />
                    <Route path="/stockists" element={<Stockists />} />
                    <Route path="/checkout/success" element={<CheckoutSuccess />} />
                    <Route path="/checkout/cancel" element={<CheckoutCancel />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </main>
            <Footer />
            <CartDrawer />
            <QuickViewModal />
            <WhatsAppFab />
            <CustomMusicBar />
        </div>
    );
}

export default App;
